import "./theme.css"
const configTheme = {
  init: () => {
    window.document.body.classList.add("theme-xmas2023")

    var elem = document.body
    var isTabActive
    var canvas = document.createElement("canvas")
    var ctx = canvas.getContext("2d")
    canvas.style.userSelect = "none"
    canvas.style.pointerEvents = "none"
    canvas.style.zIndex = 99999
    canvas.style.position = "fixed"
    canvas.style.left = canvas.style.top = "0"
    var width = elem.clientWidth || window.innerWidth
    var height = elem.clientHeight || window.innerHeight
    console.warn("width:", width, height, elem)
    var active = false

    function onResize() {
      width = elem.clientWidth || window.innerWidth
      height = elem.clientHeight || window.innerHeight
      canvas.width = width
      canvas.height = height
      ctx.fillStyle = "#FFF"

      var wasActive = active
      active = width > 700

      if (!wasActive && active) {
        window.requestAnimationFrame(snow)
        // window.requestAnimFrame && window.requestAnimFrame(update)
      }
    }

    var flakes = [],
      flakeCount = 300,
      mX = -100,
      mY = -100

    function reset(flake) {
      flake.x = Math.floor(Math.random() * canvas.width)
      flake.y = 0
      flake.size = Math.random() * 6 + 2
      flake.speed = Math.random() * 1 + 0.5
      flake.velY = flake.speed
      flake.velX = 0
      flake.opacity = Math.random() * 0.5 + 0.3
    }

    for (var i = 0; i < flakeCount; i++) {
      var x = Math.floor(Math.random() * width),
        y = Math.floor(Math.random() * height),
        size = Math.random() * 6 + 2,
        speed = Math.random() * 1 + 0.5,
        opacity = Math.random() * 0.5 + 0.3

      flakes.push({
        speed: speed,
        velY: speed,
        velX: 0,
        x: x,
        y: y,
        size: size,
        stepSize: Math.random() / 30,
        step: 0,
        opacity: opacity,
      })
    }

    function snow() {
      if (isTabActive == false) {
        return
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      for (var i = 0; i < flakeCount; i++) {
        var flake = flakes[i],
          x = mX,
          y = mY,
          minDist = 150,
          x2 = flake.x,
          y2 = flake.y

        var dist = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y)),
          dx = x2 - x,
          dy = y2 - y

        if (dist < minDist) {
          var force = minDist / (dist * dist),
            xcomp = (x - x2) / dist,
            ycomp = (y - y2) / dist,
            deltaV = force / 2

          flake.velX -= deltaV * xcomp
          flake.velY -= deltaV * ycomp
        } else {
          flake.velX *= 0.98
          if (flake.velY <= flake.speed) {
            flake.velY = flake.speed
          }
          flake.velX += Math.cos((flake.step += 0.05)) * flake.stepSize
        }

        ctx.fillStyle = "rgba(255,255,255," + flake.opacity + ")"
        flake.y += flake.velY
        flake.x += flake.velX

        if (flake.y >= canvas.height || flake.y <= 0) {
          reset(flake)
        }

        if (flake.x >= canvas.width || flake.x <= 0) {
          reset(flake)
        }

        ctx.beginPath()
        ctx.arc(flake.x, flake.y, flake.size, 0, Math.PI * 2)
        ctx.fill()
      }
      window.requestAnimationFrame(snow)
    }

    // shim layer with setTimeout fallback
    // window.requestAnimFrame = (function () {
    //   return (
    //     window.requestAnimationFrame ||
    //     window.webkitRequestAnimationFrame ||
    //     window.mozRequestAnimationFrame ||
    //     function (callback) {
    //       window.setTimeout(callback, 5000 / 60)
    //     }
    //   )
    // })()

    window.addEventListener("mousemove", function (e) {
      mX = e.clientX
      mY = e.clientY
    })

    onResize()
    window.addEventListener("resize", onResize, false)
    elem.appendChild(canvas)

    window.onfocus = function () {
      let _lastInactive = false
      if (isTabActive == false) {
        _lastInactive = true
      }
      isTabActive = true
      if (_lastInactive) {
        window.requestAnimationFrame(snow)
      }

      console.log("isTabActive:", isTabActive)
    }

    window.onblur = function () {
      isTabActive = false
      console.log("isTabActive:", isTabActive)
    }
  },
}
export default configTheme
